import { SET_AUTH, LOG_OUT } from "./mutation-types";

const { userName, token, type, userMode } = JSON.parse(
  localStorage.getItem("auth")
) || {
  userName: null,
  token: null,
  type: null,
  userMode: null
};

export default {
  state: {
    userName: userName,
    token: token,
    type: type,
    userMode: userMode
  },
  getters: {
    isLogging(state, getters, rootState) {
      if (state.userName && state.token) {
        return true;
      } else {
        return false;
      }
    },
    tokenHeaders(state, getters, rootState) {
      if (!getters.isLogging) return {};
      return { Authorization: "Bearer " + state.token };
    }
  },
  mutations: {
    [SET_AUTH](state, data) {
      const { UserName, Ticket, Type, UserMode } = data;
      state.userName = UserName;
      state.token = Ticket;
      state.type = Type;
      state.userMode = UserMode;
      const login = {
        userName: UserName,
        token: Ticket,
        type: Type,
        userMode: UserMode
      };

      localStorage.setItem("auth", JSON.stringify(login));
    },
    [LOG_OUT](state) {
      state.userName = null;
      state.token = null;
      state.type = null;
      state.userMode = null;
      localStorage.removeItem("auth");
      localStorage.removeItem("cUserInfo");
      localStorage.removeItem("supplierInfo");
      localStorage.removeItem("agreedState");
      localStorage.removeItem("basket");
    }
  }
};
